export const PATH: any = {};
PATH.userFiles = "/userfiles";
PATH.staticFiles = `${PATH.userFiles}/_static`;
PATH.fonts = `${PATH.staticFiles}/fonts`;

export const PAGE_CONTEXT = {};

export const WIDGET_GROUP = {};

export const ERROR_CODE = {
    unhandled: "500",
    unauthorized: "403",
    timeout: "408",
};

export const USER_ROLES = {
    administrator: "Administrator",
    buyer1: "Buyer1",
    buyer2: "Buyer2",
    buyer3: "Buyer3",
};

export const PAGE_TYPES = {
    accountReceivable: "AccountReceivablePage",
    retailPricingSettings: "RetailModeSettingsPage",
    accountSettings: "AccountSettingsPage",
    addresses: "AddressesPage",
    budgetManagement: "BudgetManagementPage",
    invoiceHistory: "InvoiceHistoryPage",
    myLists: "MyListsPage",
    orderHistory: "OrderHistoryPage",
    myQuotes: "RfqMyQuotesPage",
    savedPayments: "SavedPaymentsPage",
    changeCustomer: "ChangeCustomerPage",
    orderApproval: "OrderApprovalListPage",
    userAdministration: "UserListPage",
    savedOrderList: "SavedOrderListPage",
    myAccount: "MyAccountPage",
    vmiLocationDetails: "VmiLocationDetailsPage",
    vmiLocations: "VmiLocationsPage",
    vmiUsers: "VmiUsersPage",
};

export const DATE_FORMAT = {
    date: "MM/dd/y",
    dateTime: "MM/dd/y h:mm a",
};

export const ATTRIBUTE_TYPE_NAMES = {};
